import { render, staticRenderFns } from "./com-desc.vue?vue&type=template&id=22ed09f2&scoped=true"
import script from "./com-desc.vue?vue&type=script&lang=js"
export * from "./com-desc.vue?vue&type=script&lang=js"
import style0 from "./com-desc.vue?vue&type=style&index=0&id=22ed09f2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed09f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22ed09f2')) {
      api.createRecord('22ed09f2', component.options)
    } else {
      api.reload('22ed09f2', component.options)
    }
    module.hot.accept("./com-desc.vue?vue&type=template&id=22ed09f2&scoped=true", function () {
      api.rerender('22ed09f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/components/com-desc.vue"
export default component.exports